import { createHttpLink } from '@apollo/client';

export const httpLink = createHttpLink({
  uri: process.env.REACT_APP_GRAPHQL_URI,
  credentials: 'include'
});
